<form [formGroup]="form" class="flex flex-col">
    <div class="w-full xl:w-8/12">
        <section class="mb-3">
            <h2 class="text-primary-800">
                First, choose an application purpose.
            </h2>
            <p>
                Form FCC 601 is a multi-purpose form utilized to collect data
                pertaining to your proposed request. This data is used by the
                FCC to determine whether the public interest would be served by
                a grant of the request.
            </p>
        </section>
    </div>
    <div class="flex items-center w-full xl:w-5/12">
        <mat-form-field appearance="outline" class="rounded-full w-full">
            <mat-label>Select Application Purpose</mat-label>
            <mat-select formControlName="applicationPurpose" required>
                @for (purpose of applicationPurposes; track purpose.value) {
                    <mat-option [value]="purpose.value">{{
                        purpose.label
                    }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
        <img
            [matTooltipPosition]="'right'"
            matTooltip="Indicate the purpose for which the application is being filed by selecting the appropriate two-letter abbreviation from the following list. Only one purpose may be specified."
            src="assets/svg/question-tooltip.svg"
            alt="question mark"
            class="!fill-primary-700 cursor-pointer ml-2 mb-[22px]"
        />
    </div>
    @if (showCallSignSearch()) {
        <div class="w-full xl:w-8/12">
            <section class="mb-3">
                <h2 class="text-primary-800">
                    Great! Now enter your call sign.
                </h2>
            </section>
        </div>
        <div class="flex items-center w-full xl:w-5/12">
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>Call Sign</mat-label>
                <input
                    title="Call sign"
                    formControlName="callSign"
                    matInput
                    [appRegexInput]="regExPattern.Alphanumeric"
                    [imask]="imask.uppercase"
                    [maxLength]="htmlInputConstants.CALL_SIGN_MAX_LENGTH"
                />
                @if (getCallSignError(); as error) {
                    <mat-error>{{ error }}</mat-error>
                }
            </mat-form-field>
        </div>
    }
    @if (showApplicationTemplateSelectionGrid()) {
        <div class="w-full">
            <section class="mb-4 flex flex-row items-center">
                <h2 class="!mb-0 text-primary-800">
                    Optionally, select a template to start your application.
                </h2>
                <img
                    [matTooltipPosition]="'right'"
                    matTooltip='Only templates with the "NE – New" application type are available for creating applications.'
                    src="assets/svg/question-tooltip.svg"
                    alt="question mark"
                    tabindex="0"
                    class="!fill-primary-700 cursor-pointer ml-2"
                />
            </section>
        </div>
        <app-application-template-selection
            [templateApplicationMasterFormControl]="
                form.controls.templateApplicationMasterId
            "
            [applicationTemplatesAvailableForSelection]="
                applicationTemplatesAvailableForSelection
            "
            class="h-[350px]"
        ></app-application-template-selection>
    }
</form>
